<template>
  <component :is="way" ref="process" />
</template>

<script>
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
const ResponsesContent = () => import('@/components/responses/SceneContent');
const SchlumResponsesContent = () =>
  import(
    /* webpackChunkName: "schlumberger-responses-content" */ '@/process/shlumberger/components/responses/SceneContent'
  );
// const SportmasterResponsesContent = () =>
//   import(
//     /* webpackChunkName: "sportmaster-responses-content" */ '@/process/sportmaster/components/responses/scene-content'
//   );

export default {
  name: 'ResponsesScene',

  components: {
    ResponsesContent,
    SchlumResponsesContent
    // SportmasterResponsesContent
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.getProcessName === PROCESS_NAMES.SCHLUMBERGER) {
        return `${this.getProcessName}-responses-content`;
      } else {
        return 'responses-content';
      }
    }
  }
};
</script>
